import { Box, Button, Text } from 'uikit'
import { useTranslation } from 'react-i18next'
import useLocalDispatch from 'contexts/LocalRedux/useLocalDispatch'
import { setHistoryPaneState } from 'state/predictions'
import Notification from './Notification'

const PauseNotification = () => {
  const { t } = useTranslation()
  const dispatch = useLocalDispatch()

  const handleOpenHistory = () => {
    dispatch(setHistoryPaneState(true))
  }

  return (
    <Notification title={t('PREDICTION_68')}>
      <Box mb="24px">
        <Text as="p">{t('PREDICTION_69')}</Text>
        <Text as="p">{t('PREDICTION_70')}</Text>
        <Text as="p">{t('PREDICTION_71')}</Text>
      </Box>
      <Button variant="primary" width="100%" onClick={handleOpenHistory}>
        {t('PREDICTION_72')}
      </Button>
    </Notification>
  )
}

export default PauseNotification
